export const STANDARD_KABOB_HEIGHT = 48;
export const SUBMISSION_ERROR_STATUS_TEXT_FOR_NOMINEE = "Pending";
export const SUBMISSION_IN_PROCESS_STATUS_TEXT = 'In Process';
export const INTEGER_FORMAT_REGEX = /(\d)(?=(\d\d\d)+(?!\d))/g;
export const DEFAULT_ROWS_PER_PAGE = 10;
export const TECHNICAL_ERROR_MESSAGE = "This site is experiencing technical difficulties.  Please try again later.";
export const PARTIAL_INFO_MESSAGE = "Not all information may be available at this time.";
export const TOASTER_MESSAGE_REGISTRATION = "The record for the user's account is missing or invalid. Please contact support."
export const TEMPLATE_UNAVAILABLE_MESSAGE = "Template is currently being modified and unavailable for download.  Please check back later for availability.";